<template>
  <v-card-text class="pa-6">
    <div class="d-flex justify-space-between align-center mb-4">
      <h3 class="text-h6">
        <v-icon left color="success">mdi-chart-line</v-icon>
        ประวัติเงินเดือน
      </h3>
      <v-btn color="success" @click="$emit('add')">
        <v-icon left>mdi-plus</v-icon>
        เพิ่มการเลื่อนเงินเดือน
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="salaries"
      :loading="loading"
      no-data-text="ไม่มีข้อมูลเงินเดือน"
      hide-default-footer
      :items-per-page="20"
      class="elevation-1"
    >
      <template v-slot:item.salary_date="{ item }">
        <v-chip small color="info" text-color="white">
          {{ formatDate(item.salary_date) }}
        </v-chip>
      </template>
      
      <template v-slot:item.salary_amount="{ item }">
        <span class="text-h6 font-weight-medium success--text">
          {{ formatCurrency(item.salary_amount) }}
        </span>
      </template>
      
      <template v-slot:item.file="{ item }">
        <v-btn
          v-if="item.file_path"
          icon
          small
          color="success"
          @click="$emit('view-file', item.file_path, 'เอกสารเลื่อนเงินเดือน')"
        >
          <v-icon>mdi-file-pdf-box</v-icon>
        </v-btn>
        <span v-else class="grey--text">ไม่มีไฟล์</span>
      </template>
      
      <template v-slot:item.created_at="{ item }">
        <span class="text-caption grey--text">
          {{ formatDateTime(item.created_at) }}
        </span>
      </template>
      
      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="warning" @click="$emit('edit', item)" class="mr-1">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small color="error" @click="$emit('delete', item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card-text>
</template>

<script>
export default {
  name: 'SalaryHistory',
  
  props: {
    salaries: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      headers: [
        { text: 'วันที่มีผล', value: 'salary_date', align: 'center', width: '120px' },
        { text: 'ค่าตอบแทน', value: 'salary_amount', align: 'center', width: '150px' },
        { text: 'เลขที่คำสั่ง', value: 'salary_order', align: 'center' },
        { text: 'หมายเหตุ', value: 'salary_note' },        
        { text: 'วันที่บันทึก', value: 'created_at', align: 'center', width: '140px' },
        { text: 'จัดการ', value: 'actions', align: 'center', width: '100px', sortable: false }
      ]
    }
  },
  
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        return new Date(dateString).toLocaleDateString('th-TH')
      } catch {
        return dateString
      }
    },
    
    formatDateTime(dateString) {
      if (!dateString) return ''
      try {
        return new Date(dateString).toLocaleString('th-TH')
      } catch {
        return dateString
      }
    },
    
    formatCurrency(salary_amount) {
      if (!salary_amount) return '฿0'
      return new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
        minimumFractionDigits: 0
      }).format(salary_amount)
    }
  }
}
</script>